export default "__VITE_ASSET__xIXX8z3G__"